<template>
  <div v-if="orders.length > 0" class="latest-mail-outs">
    <h1 class="header">{{ $t('W2P_LATEST_ORDERS') }}</h1>
    <p class="sub-header">{{ $t('W2P_LATEST_ORDERS_SUBHEADER') }}</p>
    <div v-if="orders">
      <div
        @click="open(order)"
        v-for="order in filterLastFourOrders"
        :key="order.cartId"
      >
        <latest-orders-card-component
          :orderData="{ order }"
        ></latest-orders-card-component>
      </div>
      <order-details-modal-component
        :orderData="{ order: selectedOrder }"
        @order-detail-modal-closed="modalClosed"
        @refreshList="getOrders"
      >
      </order-details-modal-component>
    </div>

    <pn-button-container size="medium" secondary>
      <button @click="$router.push('/order/list')">
        {{ $t('W2P_LATEST_ORDERS_MORE') }}
      </button>
    </pn-button-container>
  </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import * as orderHelper from '@/helpers/orderHelper.js'

import LatestOrdersCardComponent from '../latest-orders/LatestOrdersCardComponent.vue'
import OrderDetailsModalComponent from '@/components/order-details-modal/OrderDetailsModalComponent.vue'

export default {
  components: {
    LatestOrdersCardComponent,
    OrderDetailsModalComponent
  },
  data: () => ({
    orders: [],
    selectedOrder: null
  }),
  computed: {
    ...mapState(['accessToken']),
    filterLastFourOrders() {
      const sorted = [].slice.call(this.orders).sort(function(a, b) {
        return new Date(b.orderDate) - new Date(a.orderDate)
      })
      return sorted.splice(0, 4)
    }
  },
  mounted() {
    this.getOrders()
  },
  methods: {
    open(order) {
      this.selectedOrder = order
      document.getElementById('order-details-modal').open()
    },
    modalClosed() {
      this.selectedOrder = null
    },
    getOrders() {
      axios({
        method: 'get',
        url:
          process.env.VUE_APP_W2P_API_BASE_URL +
          '/orders/orders?filterKey=status&filterValue=PLACED&filterExclude=true',
        headers: { authorization: this.accessToken }
      }).then(
        response =>
          (this.orders = response.data.orders.map(orderHelper.mapOrder))
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  color: $black;
  margin-top: 2em;
}

.sub-header {
  color: $gray700;
  margin-top: 0.5em;
  margin-bottom: 1.75em;
}

.latest-mail-outs {
  min-width: 90%;

  pn-button-container {
    width: 12.5em;
    margin-top: 1.2em;
  }
}
</style>
